'use client';
import { onMessage } from 'firebase/messaging';
import { useEffect } from 'react';

import { FirebaseProvider, useFirebase } from '@/providers/firebase-provider';

import { useToast } from './ui/use-toast';

export function FcmMessageReceiver() {
  return (
    <FirebaseProvider>
      <ConnectedFcmMessageReceiver />
    </FirebaseProvider>
  );
}

function ConnectedFcmMessageReceiver() {
  const { messaging } = useFirebase();
  const { toast } = useToast();

  useEffect(() => {
    if ('serviceWorker' in navigator) {
      try {
        navigator.serviceWorker
          .register('/service-worker.js', {
            scope: '/',
          })
          .then((registration) => {
            if (registration.installing) {
              console.info('🤖 Service worker installing');
            } else if (registration.waiting) {
              console.info('🤖 Service worker installed');
            } else if (registration.active) {
              console.info('🤖 Service worker active');
            }
          });
      } catch (error) {
        console.error(`Registration failed with ${error}`);
      }
    }

    if (messaging) {
      return onMessage(messaging, (payload) => {
        toast({ title: payload.notification?.title, description: payload.notification?.body });
      });
    }
  }, [messaging, toast]);

  return null;
}
